module.exports = intersectNode;

function intersectNode(node, point) {
  return node.intersect(point);
}



//////////////////
// WEBPACK FOOTER
// ./~/dagre-d3/lib/intersect/intersect-node.js
// module id = 670
// module chunks = 0